const API_ERROR_LOGIN = 'API_ERROR_LOGIN';
const API_ERROR_SET_PASSWORD = 'API_ERROR_SET_PASSWORD';
const API_ERROR_ASK_FOR_RESET_EMAIL = 'API_ERROR_ASK_FOR_RESET_EMAIL';
const API_COMMON_ERROR = 'API_COMMON_ERROR';
const API_EXPERIENCE_ERROR = 'API_EXPERIENCE_ERROR';

const apiErrorLogin = (response) => ({
  type: API_ERROR_LOGIN,
  payload: {
    response
  }
});

const apiErrorSetPassword = (response) => ({
  type: API_ERROR_SET_PASSWORD,
  payload: {
    response
  }
});

const apiAskForResetEmailError = (response) => ({
  type: API_ERROR_ASK_FOR_RESET_EMAIL,
  payload: {
    response
  }
});

const apiCommonError = (response) => ({
  type: API_COMMON_ERROR,
  payload: {
    response
  }
});

const apiExperienceError = (response) => ({
  type: API_EXPERIENCE_ERROR,
  payload: {
    response
  }
});

export {
  API_ERROR_LOGIN,
  API_ERROR_SET_PASSWORD,
  API_ERROR_ASK_FOR_RESET_EMAIL,
  API_COMMON_ERROR,
  API_EXPERIENCE_ERROR,
  apiExperienceError,
  apiCommonError,
  apiAskForResetEmailError,
  apiErrorSetPassword,
  apiErrorLogin
};
